import type { Scope } from "./types";

/**
 * ═══ OÙ ATTERRIT LA PROCHAINE ÉCRITURE ═══
 *
 * Trois états, et non deux :
 *
 *   `reference`  la langue par défaut, sans typologie. C'est la version qui sert de
 *                repli à toutes les autres : écrire ici, c'est écrire pour tout le monde.
 *   `language`   une AUTRE langue. Ce qu'on écrit ne vaut que pour elle.
 *   `typo`       une typologie. La plus étroite des trois, et elle passe devant la
 *                langue — comme dans la cascade elle-même.
 *
 * ⚠️ LE DEUXIÈME MANQUAIT, ET C'EST CE QUI COÛTAIT. Le panneau ne signalait que la
 * typologie ; écrire dans une autre langue que la référence est pourtant une surcharge
 * au même titre, et son bandeau était du même gris que celui de la référence. On règle
 * vingt lignes en anglais en croyant régler le site, et on ne le découvre qu'en le
 * relisant en français.
 *
 * ⚠️ PURE ET PARTAGÉE, parce qu'elle a maintenant DEUX lecteurs : le bandeau du panneau
 * et celui du châssis. Deux copies de cette règle, c'est le jour où l'un des deux
 * annonce une surcharge que l'autre ignore.
 */
export type ScopeKind = "reference" | "language" | "typo";

export function scopeKindOf(scope: Scope): ScopeKind {
  if (scope.typoId !== null && scope.typoId !== undefined) return "typo";
  return scope.languageId === scope.defaultLanguageId
    ? "reference"
    : "language";
}
